import { Installation } from '../microservices';
import { getBaseUrl } from '../../maps/apiEnvironmentMap';

export class InstallationRequestGET {
  readonly method: string = 'installations';
  public buildURL(installationId: string) {
    let baseURL = getBaseUrl('companies');
    let url = `${baseURL}/${this.method}/${installationId}`;
    return url;
  }
  public generateConfig(token: string) {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return config;
  }
}
export type InstallationResponseGET = {
  status: string;
  message: string;
  data: {
    installation: Installation;
    message: string;
    errors: any;
  };
};
